import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Zone } from "../models/zone"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ZoneService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'zone/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllZones(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Zone>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllZones?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  getAllStatesbyzone(State_Id?: string): Observable<Array<Zone>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllStatesbyZone/' + (State_Id ? State_Id : '')  ).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewZone(ZoneID?: string): Observable<Array<Zone>> {
    return this.httpService.get(this.apiEndpoint + 'viewZone/' + (ZoneID ? ZoneID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveZone(locations: Zone): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveZone/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteZone(ZoneID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteZone/' + (ZoneID ? ZoneID : '00000000-0000-0000-0000-000000000000'), ZoneID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(ZoneId?: string,Code?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?&ZoneId=' + (ZoneId ? ZoneId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }

  checkEmail(Emailid?: string, ZoneId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&ZoneId=' + (ZoneId ? ZoneId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }
}
